import { Collection, MultilineInput, Radio } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { TextWithPictureField } from "../../../Models/Description/TextWithPicture/TextWithPictureField";
import { SinglePictureEdit } from "../../../Pages/Main/SinglePictureEdit";
import { FieldEditor } from "../../Utils/FieldEditor";
import { Tab } from "../../../Models/Product/Tab";
import { FormRow, FormPrinter } from "../../../Pages/Product/InputsPrinter";


export class TextWithPictureEditor extends FieldEditor
{
    constructor(description: TextWithPictureField, descriptions: Collection<Field>, tabs: Collection<Tab>)
    {
        super("TextWithPicture", description, descriptions, tabs, [
            new FormPrinter([
                new FormRow("Tekst", new MultilineInput(description.Text).Rows(8).TextAlignLeft().Padding(12).Placeholder("Markdown")),
                new FormRow("Pozycja zdjęcia", new Radio(description.PicturePosition, { "Po lewej": "left", "Po prawej": "right" }).Class("radio")),
                new FormRow("Zdjęcie", new SinglePictureEdit(description.PictureUrl)),
            ]),
        ]);
    }
}
